<template>
	<div class="col-md-7 col-lg-8 wrapper-rounded-content content-mybookingdetails">

		<div class="bg-blue-multiply rounded-corners"></div>

		<div class="row justify-content-center no-gutters">
			<div class="col-lg-6 pr-2">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">Station</p>
						</div>
					</div>
					<div class="row station-content">
						<div class="col-auto align-self-start station-icon">
							<img class="icon-blue" src="/static/img/icon-station-blue.png">
						</div>
						<div class="col align-self-center">
							<h4 class="sum-text text-left">{{ station.name }} - {{ station.city }},<br>{{ station.street }}</h4>
						</div>
						<div class="col-auto align-self-center" v-if="ischangeable">
							<router-link :to="{name: 'PagePlace'}">{{ $t('Change') }}</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-6 pl-2">
				<div class="sum-item">
					<div class="row absolute">
						<div class="col-12">
							<p class="sum-label">{{ $t('Car') }}</p>
						</div>
					</div>
					<div class="row align-items-center car-content no-gutters">
						<div class="col-auto">
							<h4 class="sum-text">{{vehicle.vehicle_description }}</h4>
						</div>
						<div class="col">
							<img class="img-responsive" width="110" :src="(carGroup.download ? carGroup.download : '/static/img/car-dummy.png')">
						</div>
						<div class="col"  v-if="ischangeable">
							<router-link :to="{name: 'PageCar'}">{{ $t('Change') }}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row justify-content-center no-gutters">
			<div class="col-lg-6 pr-2">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">{{ $t('Period') }}</p>
						</div>
					</div>
					<div class="row time-content">
						<div class="col-auto align-self-start time-icon">
							<img class="icon-blue" src="/static/img/icon-time-blue.png">
						</div>
						<div class="col align-self-center">
							<h4 class="sum-text text-left">{{ formatter.OUTPUT_DATE_ONLY_DATE(reservation.startdate) }} - {{ formatter.OUTPUT_TIME( reservation.starttime ) }} {{ $t('Uhr') }}<br />{{ formatter.OUTPUT_DATE_ONLY_DATE(reservation.enddate) }} - {{ formatter.OUTPUT_TIME( reservation.endtime ) }} {{ $t('Uhr') }}</h4>
						</div>
						<div class="col-auto align-self-center"  v-if="ischangeable">
							<router-link :to="{name: 'PageTime'}">{{ $t('Change') }}</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-6 pl-2">
				<div class="sum-item">
					<div class="row">
						<div class="col-12">
							<p class="sum-label">{{ $t('Price') }}</p>
						</div>
					</div>
					<div class="row price-content">
						<div class="col-7 align-self-Start">
							<p class="sum-price"> {{ formatter.OUTPUT_PRICE(price) }} €</p>
						</div>
						<div class="col-5 align-self-center" style="text-align: right">
							<button v-if="reservation.reservation != 'N'" type="button" @click="showModal" class="btn btn-outline-info btn-wp">
								{{ $t('Stornieren') }}
							</button>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row justify-content-center">
			<router-link :to="{name: 'PageMybookings'}"><button type="button" class="btn btn-primary btn-wp">{{ $t('Zurück zur Übersicht')}}</button></router-link>
		</div>

		<modal v-show="isModalVisible"  @clicked="closeModal" :isModalVisible="isModalVisible" :largeModal="true" :twoButtons="true" >
			<h3 slot="headline">{{ $t('Wollen Sie ihre Reservierung stornieren?') }}</h3>
			<p slot="text">{{ $t('') }}</p>
			<template slot="firstBtn">{{ $t('Ja') }}</template>
			<template slot="closeBtn">{{ $t('Nein') }}</template>

		</modal>

		<div v-show="isModalVisible"  @click="closeModal" class="modal-backdrop show"></div>

	</div>

</template>

<script>
import { mapGetters } from 'vuex';
import formatter from '@/store/orm/helpers/formater';

export default {
	name: 'PageMybookingsDetails',
	computed: {

		...mapGetters('orm/reservation', {
	    	user_session: 'user_session'
	    }),

	    ...mapGetters('orm', {
	    	resGroups: 'groups',
			resGroup: 'group',
			resStation: 'station',
	    }),
	},
	data() {
		return {
			isModalVisible: false,
			formatter,
			customer_data: {},
			ischangeable: false,
			carGroup: '',
			vehicle: '',
			reservation: '',
			station: '',
			price: ''
		};
	},
	mounted() {
		var self = this;
		this.$emit("isActive", "bookings");

		if(!this.$route.params.result){
			return this.$router.push({name: "PageMybookings"});
		}

		// this.$store.dispatch('orm/GET_CUSTOMER')
		// .then(result => {
		// 	console.log('GET_CUSTOMER', result)
		// 	self.customer_data = result
		// }).catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		self.reservation = this.$route.params.result.reservation;
		self.vehicle = this.$route.params.result.vehicle;
		self.price = this.$route.params.result.bill.length !== 0 ? this.$route.params.result.bill[2].price : '0';
		

		// this.$store.dispatch('orm/GET_GROUPS')
		// .then(groups => {
		// 	self.carGroup = self.resGroup(self.vehicle.car_group);

		// }).catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		self.carGroup = this.$store.getters['orm/group'](self.vehicle.car_group);

		// this.$store.dispatch('orm/GET_STATIONS')
		// .then(stations => {
		// 	self.station = self.resStation(self.reservation.station);	

		// }).catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		self.station = this.$store.getters['orm/station'](self.reservation.station);

		

	},
	methods: {
		cancelReservation(ev){
			var self = this;

			console.log('ev');

			if(!self.user_session) {
				this.$router.push({name: "PageLogin", params: {redirect: 'PageSummary' }});
				console.log('No SESSION');
			} else {

				this.$store.dispatch('orm/reservation/CANCEL_RESERVATION', self.reservation.id)
				.then(result => {
					//self.isModalVisible = true;
					this.$router.push({name: "PageMybookings", params: {redirect: 'PageMybookingsDetails' }});
					this.isModalVisible = false;
        			document.body.classList.remove("modal-open");
					

				})
				.catch(err => { this.$store.commit("core/ADD_ERROR", err); });
			}
		},
		showModal() {
			this.isModalVisible = true;
			document.body.classList.add("modal-open");
      	},
      	closeModal(value) {
      		switch (value) {
			  case 'close':
			  	this.isModalVisible = false;
        		document.body.classList.remove("modal-open");
			  	break;
			  case 'submit':
			  	this.cancelReservation();
			  	break;
			  default:

			}        	
      	},
		

	}
}

</script>



// WEBPACK FOOTER //
// src/components/Pages/PageMybookingdetails.vue